const E="base";export{E as REDUCER_BASE_NAME};
